import React, { Component } from "react";
import ContainerDimensions from "react-container-dimensions";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

import { Box } from "rebass";
import Pagination from "./carousel/Pagination";
import { connect } from "../../utils";
import ContentCarousel from "./ContentCarousel";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const bgPropertiesDefault = {
  size: "cover",
  position: "center center",
  repeat: "no-repeat",
  ratio: 1.8
};

class RowCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0
    };
  }
  handleChangeIndex = index => {
    this.setState({
      index
    });
  };

  renderWithBackgroundImage = (values, children, contentWidth) => {
    const { id, layoutState } = this.props;
    const { auto, interval, direction } = values.carousel;
    const { index } = this.state;
    let autoPlay = false;
    if (children.length > 1) {
      autoPlay = auto;
    }
    const intervalswipe = interval * 1000;
    const bgProps = values.bgProps ? values.bgProps : bgPropertiesDefault;
    const srcMobile =
      values.backgroundImage.urlMobile || values.backgroundImage.url || "";
    const srcDesktop =
      values.backgroundImage.url || values.backgroundImage.urlMobile || "";
    let important = {
      backgroundImage: `url("${srcDesktop}")`,
      backgroundSize: bgProps.size,
      backgroundPosition: bgProps.position,
      backgroundRepeat: bgProps.repeat
    };
    return (
      <ContainerDimensions>
        {({ width, height }) => {
          const minHeight = width / bgProps.ratio;
          if (width < 768) {
            important.backgroundImage = `url("${srcMobile}")`;
          }
          return (
            <div
              style={{
                ...important,
                minHeight: minHeight,
                display: "flex",
                width: "inherit",
                maxWidth: contentWidth
              }}
            >
              <div
                style={{
                  width: "inherit",
                  display: "flex",
                  alignItems: "stretch",
                  flexWrap: "wrap"
                }}
              >
                <Box w={[1]} style={styles.imageContainer}>
                  <AutoPlaySwipeableViews
                    index={index}
                    onChangeIndex={this.handleChangeIndex}
                    interval={intervalswipe}
                    direction={direction}
                    autoplay={autoPlay}
                  >
                    {layoutState.getItemJS(id).children.map((item, index) => {
                      return (
                        <ContentCarousel
                          {...this.props}
                          key={index}
                          children={children[index]}
                        />
                      );
                    })}
                  </AutoPlaySwipeableViews>
                  <div style={styles.pagination}>
                    <Pagination
                      dots={children.length}
                      index={index}
                      onChangeIndex={this.handleChangeIndex}
                    />
                  </div>
                </Box>
              </div>
            </div>
          );
        }}
      </ContainerDimensions>
    );
  };

  renderWithBackgroundColor = (values, children, contentWidth) => {
    const { id, layoutState } = this.props;
    const { auto, interval, direction } = values.carousel;
    const { index } = this.state;
    let autoPlay = false;
    if (children.length > 1) {
      autoPlay = auto;
    }
    const intervalswipe = interval * 1000;
    return (
      <ContainerDimensions>
        {({ width, height }) => {
          return (
            <div style={{ maxWidth: contentWidth, width: "inherit" }}>
              <div
                style={{
                  width: "inherit",
                  display: "flex",
                  alignItems: "stretch",
                  flexWrap: "wrap"
                }}
              >
                <Box w={[1]} style={styles.imageContainer}>
                  <AutoPlaySwipeableViews
                    index={index}
                    onChangeIndex={this.handleChangeIndex}
                    interval={intervalswipe}
                    direction={direction}
                    autoplay={autoPlay}
                  >
                    {layoutState.getItemJS(id).children.map((item, index) => {
                      return (
                        <ContentCarousel
                          {...this.props}
                          key={index}
                          children={children[index]}
                        />
                      );
                    })}
                  </AutoPlaySwipeableViews>
                  <div style={styles.pagination}>
                    <Pagination
                      dots={children.length}
                      index={index}
                      onChangeIndex={this.handleChangeIndex}
                    />
                  </div>
                </Box>
              </div>
            </div>
          );
        }}
      </ContainerDimensions>
    );
  };

  render() {
    const { id, layoutState, children } = this.props;
    const { values } = layoutState.getItemJS(id).props;
    const valuesBody = layoutState.getItemJS("root").props.values;
    const contentWidth = values.width.contentWidth + values.width.type;
    const isBackgroundImage = values.isBackgroundImage
      ? this.renderWithBackgroundImage(values, children, contentWidth)
      : this.renderWithBackgroundColor(values, children, contentWidth);
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flex: 1,
          backgroundColor: values.backgroundColor,
          justifyContent: "center"
        }}
      >
        <div
          style={{
            boxSizing: "border-box",
            position: "relative",
            backgroundColor: values.backgroundColor,
            height: "100%",
            padding: values.padding,
            minHeight: children.length > 1 ? null : 30,
            minWidth: children.length > 1 ? null : 30,
            display: "flex",
            flex: 1,
            maxWidth: valuesBody.contentWidth,
            width: "inherit",
            justifyContent: "center"
          }}
        >
          {isBackgroundImage}
        </div>
      </div>
    );
  }
}

const styles = {
  pagination: {
    position: "absolute",
    width: "100%",
    marginTop: "-24px"
  },
  imageContainer: {
    position: "relative",
    height: "100%"
  }
};

export default connect("layoutState")(RowCarousel);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/RowCarousel.js